export function licenceUrlsOf(format) {
    var _a, _b;
    return {
        ...(((_a = format.drm) === null || _a === void 0 ? void 0 : _a["com.widevine.alpha"])
            ? { widevine: format.drm["com.widevine.alpha"].licenseServerUrl }
            : {}),
        ...(((_b = format.drm) === null || _b === void 0 ? void 0 : _b["com.microsoft.playready"])
            ? { playready: format.drm["com.microsoft.playready"].licenseServerUrl }
            : {}),
    };
}
